import { parseApiError, getErrorMessage } from '../../utils/errorUtils';

/**
 * User-facing message for a failed AI chat request (#382), from the HTTP status and the
 * parsed JSON body. Each cause gets its own message instead of a generic "connection" error.
 * `t` is bound to the `common` namespace.
 */
export function describeChatError(status, data, t) {
  const parsed = parseApiError(data);
  if (parsed.error_code === 'SERVICE_INIT_FAILED') return t('aiChatbot.errors.notConfigured');
  if (status === 401 || status === 403) return t('aiChatbot.errors.forbidden');
  if (status === 404 && /conversation not found/i.test(parsed.message)) return t('aiChatbot.errors.conversationGone');
  if (status === 422 && /at most/i.test(JSON.stringify(data || {}))) return t('aiChatbot.errors.tooLong');
  if (status === 429) return t('aiChatbot.errors.rateLimited');
  const message = parsed.message ? getErrorMessage(parsed, t) : '';
  return t('aiChatbot.errors.server', { status, message: message || t('errors.INTERNAL_SERVER_ERROR') });
}

/** Error thrown for a non-OK chat response; `userMessage` is ready to show. */
export async function chatResponseError(response, t) {
  let data = null;
  try {
    data = await response.json();
  } catch {
    // body is not JSON
  }
  const error = new Error(`HTTP ${response.status}`);
  error.status = response.status;
  error.conversationGone = response.status === 404 && /conversation not found/i.test(parseApiError(data).message);
  error.userMessage = describeChatError(response.status, data, t);
  return error;
}
